import React from "react";
import { Box } from "@mui/material";
import { keyframes } from "@mui/system";
import { alpha } from "@mui/material/styles";

export type ChartNumberSkeletonProps = {
  minHeight?: number;
};

const pulse = keyframes`
  0% { opacity: 0.3; }
  50% { opacity: 0.6; }
  100% { opacity: 0.3; }
`;

const float = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
  100% { transform: translateY(0); }
`;

const ChartNumberSkeleton: React.FC<ChartNumberSkeletonProps> = (props) => {
  const minHeight = props.minHeight ?? 160;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: minHeight,
        minHeight,
        p: 2,
        gap: 1.25,
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          backgroundColor: (theme) => alpha(theme.palette.grey[400], 0.3),
          animation: `${float} 3s ease-in-out infinite`,
        }}
      />

      <Box
        sx={{
          width: 200,
          maxWidth: "85%",
          height: 20,
          borderRadius: 1,
          backgroundColor: (theme) => alpha(theme.palette.grey[500], 0.4),
          animation: `${pulse} 2s ease-in-out 0.15s infinite`,
        }}
      />

      <Box
        sx={{
          width: 180,
          maxWidth: "75%",
          height: 12,
          borderRadius: 1,
          backgroundColor: (theme) => alpha(theme.palette.grey[400], 0.2),
          animation: `${pulse} 2s ease-in-out 0.3s infinite`,
        }}
      />
    </Box>
  );
};

export default ChartNumberSkeleton;
